import { Skeleton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AttToken from "../../helpers/attToken";
import { trackEventMatomo } from "../../helpers/matomo";
import PowerBi from "../../service/PowerBi";
import { FullHeightStatisticsContainer } from "./StatisticsStyle";

const powerBiService = new PowerBi();

export default function StatisticsComponent() {
  const { t } = useTranslation("translation");
  const [embedUrl, setEmbedUrl] = useState();
  const [accessToken, setAccessToken] = useState();

  const { data, isLoading, isFetching, isSuccess } = useQuery({
    queryKey: ["GET_DEFAULT_DASHBOARD"],
    queryFn: async () => {
      try {
        const token = await AttToken();
        if (!token) throw new Error(t("Dashboard.tokenInvalid"));
        const promise = toast.promise(
          async () => {
            const response = await powerBiService.getDefaultDashboard(token);
            if (!response) throw new Error(t("Dashboard.notFound"));
            if (response.error === "Permition Denied - User not allowed to call this API") {
              toast.error(t("Dashboard.permissionDenied"));
              throw new Error(t("Dashboard.permissionDenied"));
            }
            if (!response) {
              throw new Error(t("Dashboard.notFound"));
            }
            return response;
          },
          {
            pending: t("Dashboard.loading"),
            error: t("Dashboard.loadError"),
          },
          { toastId: "get-default-dashboard" },
        );
        return promise;
      } catch (err) {
        throw new Error(t("Dashboard.loadError"));
      }
    },
    staleTime: 5 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 0,
  });

  const onLoading = isLoading || isFetching;

  useEffect(() => {
    if (isSuccess && data) {
      trackEventMatomo('dashboard', 'sucesso', 'carregamento', 'dashboard padrão carregado');
      setEmbedUrl(data.embedUrl?.[0].embedUrl);
      setAccessToken(data.accessToken);
    }
  }, [onLoading, data, isSuccess]);

  return (
    onLoading ? (
      <Skeleton variant="rounded" width={"100%"} height="100vh" />
    ) : (
      embedUrl &&
      accessToken && (
        <FullHeightStatisticsContainer>
          <PowerBIEmbed
            cssClassName="powerBiStyle"
            key={"0d47a889-7d45-4f97-bda7-1996436ecaff"}
            embedConfig={{
              type: "report", // Supported types: report, dashboard, tile, visual and qna
              id: "0d47a889-7d45-4f97-bda7-1996436ecaff",
              embedUrl,
              accessToken,
              tokenType: models.TokenType?.Embed, // PowerBiClient.Models.TokenType.Embed
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: true,
                  },
                },
              },
            }}
            eventHandlers={new Map([
              ['error', () => trackEventMatomo('dashboard', 'erro', 'carregamento', 'erro no dashboard padrão')],
            ])}
          />
        </FullHeightStatisticsContainer>
      )
    )
  );
}
